(function () {
	const galleries = $('.gallery');

	galleries.each(function () {
		const gallery = new Swiper($(this).find('.swiper-container'), {
			speed: 700,
			spaceBetween: 0,
			loop: true,
			pagination: {
				el: $(this).find('.swiper-pagination'),
				clickable: true
			},
			navigation: {
				prevEl: $(this).find('.swiper-button-prev'),
				nextEl: $(this).find('.swiper-button-next')
			}
		});
	});



	// This was applied before, cancelled with new design
		// This has been un-cancelled
	$('section.banner img').first().each(function () {
		const img = this;
		const op = parseFloat(window.getComputedStyle(img)['opacity']);

		window.addEventListener('scroll', function () {
			const value = op + (window.scrollY / (window.innerHeight / 2) * (1 - op));
			if (value <= 1) img.style.opacity = value;
			else img.style.opacity = 1;
		});
	});
})();